"use client";
import { n as useLinkRenderer } from "./link-provider-erp27xeaxlv7jgvb.js";
import React from "react";
import { jsx } from "react/jsx-runtime";
//#region src/utils/container.tsx
var Container = React.forwardRef((props, ref) => {
	const renderLink = useLinkRenderer();
	if (props.href !== void 0) {
		const { children, external, as: _as, href, ...rest } = props;
		return renderLink({
			ref,
			href,
			to: href,
			...external ? {
				target: "_blank",
				rel: "noopener noreferrer"
			} : {},
			...rest,
			children
		});
	}
	if (props.onClick) {
		const { children, as: _as, href: _href, ...rest } = props;
		return /* @__PURE__ */ jsx("button", {
			type: "button",
			ref,
			...rest,
			children
		});
	}
	const { as: Component = "div", children, onClick: _onClick, href: _href, ...rest } = props;
	return /* @__PURE__ */ jsx(Component, {
		ref,
		...rest,
		children
	});
});
Container.displayName = "Container";
//#endregion
export { Container as t };

